<template>
  <div class="mt-2 ml-2">
    <v-dialog v-model="getRacesSilksDialog" max-width="300px">
      <v-card>
        <v-toolbar color="#425058" dark dense>
          <div class="titleBar-content">
            <v-toolbar-title class="raceResults-title">
              Races & Silks
            </v-toolbar-title>
            <v-btn class="cancelButton" icon small><v-icon class="white--text">mdi-close</v-icon></v-btn>
          </div>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text style="text-align: center; padding: 12px;">
          <!-- <v-btn color="error" @click="deleteUserConfirmation = false" small>Cancel</v-btn> -->
          <v-btn color="success" @click="loadData" small>Get Races & Silks</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container v-if="!getRacesSilksDialog" style="height:97vh; overflow: hidden; margin-right: 0; margin-left: 0; padding-bottom: 30px;">
      <v-row style="height: 100%;">
        <v-col md="6" style="height: 100%;" class="pr-0">
          <v-toolbar class="mb-3" height="30px" color="#425058" dark>
            <h4>Race</h4>
          </v-toolbar>
          <div class="raceContainer" style="height:97%;">
            <div class="headerGrid" style="">
              <RaceHeader/>
            </div>
            <div class="mt-2 pb-8 raceDetail" style="height: 100%; position: relative; overflow-y: auto;">
              <RaceDetail/>
            </div>
          </div>
        </v-col>
        <v-col md="6">
          <v-toolbar class="mb-3 mt-0" height="30px" color="#425058" dark>
            <h4>Styles & Shapes</h4>
          </v-toolbar>
          <Silks/>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import RaceHeader from '../components/RaceHeader'
import RaceDetail from '../components/RaceDetail'
import Silks from './Silks'
import { mapActions, mapGetters } from 'vuex'

export default {
  data: () => ({
    dialog: true
  }),
  components: {
    RaceDetail,
    RaceHeader,
    Silks
  },
  mounted () {
    // this.fetchRaces()
    this.fetchUserFilters()
  },
  computed: {
    ...mapGetters(['getRacesSilksDialog'])
  },
  methods: {
    ...mapActions(['fetchRaces', 'fetchUserFilters', 'updateRacesSilksDialog']),
    loadData() {
      this.fetchRaces()
      this.updateRacesSilksDialog({ value: false })
    }
  },
}
</script>

<style scoped>
  .raceContainer {
    display: flex;
    flex-direction: column;
    height:inherit;
  }
  .headerGrid {
    flex-basis: 92px;
  }
  @media (min-width: 1264px) {
    .container {
      max-width: 100%;
    }
  }
  /* @media (min-height: 878px) {
    .raceDetail {
      height: 100% !important;
    }
  } */

</style>
